import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { queryOptions } from "@tanstack/react-query";
import { PaymentInfo, SubscriptionTypeName } from "@vixi/types";
import { AxiosResponse } from "axios";

export const paymentInfoQueryOptions = () =>
  queryOptions({
    queryKey: ["plans"],
    queryFn: async () => {
      const response = (await api.get(endpoints.getPaymentInfo)) as AxiosResponse<PaymentInfo>;
      response.data.subscriptionTypes.reverse();
      response.data.subscriptionTypes = response.data.subscriptionTypes
        .map((subscriptionType) => ({
          ...subscriptionType,
          name: subscriptionType.name.toLowerCase() as SubscriptionTypeName,
        }))
        .filter((subscriptionType) => (subscriptionType.name as string) !== "none");

      return response.data;
    },
  });
